import Cookies from "js-cookie";
var sessionStorage = window.sessionStorage;

const TokenKey = "vue_pet_video_template_token";
const InfoKey = "vue_pet_video_template_info";
const TopNav = "vue_pet_video_template_TopNav";
const MenuBar = "vue_pet_video_template_MenuBar";
const UserHeadPhoto = "vue_pet_video_template_UserHeadPhoto";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function setInfo(userInfo) {
  // console.log(userInfo);
  if (userInfo) {
    const res = JSON.stringify(userInfo);
    return Cookies.set(InfoKey, res);
  }
}

export function getInfo() {
  let res = Cookies.get(InfoKey);
  if (res) {
    res = JSON.parse(res);
    return res;
  }
}

// 保存导航栏信息
export function setTopNav(userInfo) {
  if (userInfo) {
    const res = JSON.stringify(userInfo);
    return Cookies.set(TopNav, res);
  }
}

export function getTopNav() {
  let res = Cookies.get(TopNav);
  if (res) {
    res = JSON.parse(res);
    return res;
  }
}

export function removeInfo() {
  return Cookies.remove(InfoKey);
}

export function getIP() {
  return Cookies.get("IP");
}

export function setIP(IP) {
  return Cookies.set("IP", IP);
}

// 菜单栏设置
export function getMenuBar() {
  let res = localStorage.getItem(MenuBar);
  if (res) {
    res = JSON.parse(res);
    return res;
  }
}

export function setMenuBar(Menu) {
  if (Menu) {
    const res = JSON.stringify(Menu);
    return localStorage.setItem(MenuBar, res);
  }
}

export function removeMenuBar() {
  return localStorage.removeItem(MenuBar);
}

// 保存 头像
export function getUserHeadPhoto() {
  let res = localStorage.getItem(UserHeadPhoto);
  if (res) {
    res = JSON.parse(res);
    return res;
  }
}

export function setUserHeadPhoto(Menu) {
  if (Menu) {
    const res = JSON.stringify(Menu);
    return localStorage.setItem(UserHeadPhoto, res);
  }
}

export function removeUserHeadPhoto() {
  return localStorage.removeItem(UserHeadPhoto);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js